import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowRight, FiExternalLink } from 'react-icons/fi';
import { getConveniosDestacados, Convenio } from '../data/convenios-data';

export default function BeneficiosPreview() {
  const { t } = useTranslation();
  const conveniosDestacados = getConveniosDestacados().slice(0, 4);

  const getCategoryColor = (categoria: string): string => {
    const colors: Record<string, string> = {
      educacion: '#6366f1',
      gastronomia: '#f59e0b',
      salud: '#10b981',
      servicios: '#3b82f6',
      experiencias: '#8b5cf6'
    };
    return colors[categoria] || '#6b7280';
  };

  const getCategoryIcon = (categoria: string): string => {
    const icons: Record<string, string> = {
      educacion: 'bi-mortarboard',
      gastronomia: 'bi-cup-hot',
      salud: 'bi-heart-pulse',
      servicios: 'bi-briefcase',
      experiencias: 'bi-compass'
    };
    return icons[categoria] || 'bi-star';
  };

  return (
    <section className="py-5" style={{ backgroundColor: '#fff' }}>
      <div className="container">
        {/* Beneficios exclusivos para miembros */}
        <div className="row">
          <div className="col-12">
            <div
              className="p-4 rounded-3 d-flex flex-wrap justify-content-between align-items-center"
              style={{ backgroundColor: 'rgba(10, 47, 39, 0.05)' }}
            >
              <div className="mb-3 mb-md-0">
                <h5 className="fw-bold mb-1" style={{ color: '#0a2f27' }}>
                  {t('beneficiosPreview.memberBenefits')}
                </h5>
                <p className="text-muted mb-0">
                  {t('beneficiosPreview.memberBenefitsDesc')}
                </p>
              </div>
              <Link
                to="/list-with-us"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                {t('beneficiosPreview.joinNow')}
                <FiExternalLink className="ms-2" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
